import { Component } from '@angular/core';

@Component({
  selector: 'app-help-bar',
  templateUrl: './help-bar.component.html',
  styleUrls: ['./help-bar.component.scss']
})
export class HelpBarComponent {

}
